module.exports = __webpack_public_path__ + "img/Left.bf679c47.svg";